import {useMemo} from 'react';
import {Output, WebMidi} from 'webmidi';

type MIDI_STATUS = 'granted' | 'denied' | 'prompt';

class WebMidiService {
  currentOutput: Output | null = null;

  setCurrentOutput(pulsoidMidiDevice: Output) {
    this.currentOutput = pulsoidMidiDevice;
  }

  connected(): Boolean {
    return this.currentOutput !== null;
  }

  sendHeartRate(heartRate: number) {
    if (this.currentOutput) {
      let channel = this.currentOutput.channels[1];
      let note = heartRate % 10;
      let rawAttack = Math.floor(heartRate / 10);
      channel.playNote(note, {
        rawAttack: rawAttack,
      });
    }
  }
  async status(): Promise<MIDI_STATUS> {
    // @ts-ignore
    let permissionStatus = await navigator.permissions.query({name: 'midi'});

    switch (permissionStatus.state) {
      case 'granted':
        return 'granted';
      case 'denied':
        return 'denied';
      case 'prompt':
        return 'prompt';
      default:
        return 'denied';
    }
  }

  async enable(): Promise<MIDI_STATUS> {
    try {
      await WebMidi.enable();
    } catch (e) {
      console.error(e);
    }
    return await this.status();
  }

  async refreshDevices(): Promise<Output[]> {
    await this.enable();
    return WebMidi.outputs;
  }
}

const useMidi = () => {
  return useMemo(() => new WebMidiService(), []);
};

export {useMidi, WebMidiService};
